<template>
  <v-layout justify-center align-center wrap-reverse>
    <span
      style="text-decoration-line: underline"
      @click="$store.commit('cart/setQuantity', { quantity: 0, productId: productId })"
      :class="{ 'clickable': !!quantity, 'grey--text': !quantity }"
      class="my-2">
      {{ $t("catalog.remove") }}
    </span>
    <span class="ml-6 d-flex align-center">
      <v-btn fab small :disabled="!quantity" color="primary" @click="$store.commit('cart/setQuantity', { quantity: quantity - 1, productId: productId })">
        <v-icon>remove</v-icon>
      </v-btn>
      <span class="px-7 headline grey--text text--darken-1" :class="{ 'text--darken-3': !!quantity }">{{quantity}}</span>
      <v-btn fab small color="primary" @click="$store.commit('cart/setQuantity', { quantity: quantity + 1, productId: productId })">
        <v-icon>add</v-icon>
      </v-btn>
    </span>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    productId: { type: String, required: true },
  },
  computed: {
    ...mapState({
      products: ({ cart }) => cart.products,
    }),
    quantity () {
      const stateProduct = this.products.find(stateProduct => stateProduct.product.id === this.productId)
      return stateProduct ? stateProduct.quantity : 0
    },
  },
}
</script>
